// add the 'touch-device' class for touch devices
function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}

if (isTouchDevice()) {
  document.body.classList.add('touch-device');
}
